module.exports = __webpack_public_path__ + "static/media/brazilianfanparrot.d876b7ae.gif";